<template>
  <VCard class="IntegrationPlaceHolderCard">
    <VCardTitle>
      <component
        :is="logoHref ? 'a' : 'span'"
        :href="logoHref"
        target="_blank"
        class="logo-wrapper"
      >
        <VImg
          :alt="logoAlt"
          :src="logoSrc"
          :max-width="logoMaxWidth"
          :height="logoHeight"
        />
      </component>
    </VCardTitle>
    <VCardText class="text-center">
      В разработке, следите за
      <a
        :href="newsHref"
        target="_blank"
      >
        новостями
      </a>
    </VCardText>
  </VCard>
</template>

<script>
export default {
  name: 'IntegrationPlaceHolderCard',
  props: {
    logoSrc: { type: String, required: true },
    logoAlt: { type: String, required: true },
    logoMaxWidth: { type: String, default: '300px' },
    logoHeight: { type: String, default: '50px' },
    logoHref: { type: String, default: null },
    newsHref: { type: String, default: 'https://it-solution.ru/articles/' },
  },
}
</script>

<style lang="sass" scoped>
  .logo-wrapper
    margin: 0 auto
</style>
